module.exports = __webpack_public_path__ + "img/T-box Icon - white.8cc27090.svg";